"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var debug = require("debug")("knack.formatter.formatters.image");
var _ = require("lodash");
var formatIntoTag = function formatIntoTag(src) {
  return "<img src=\"".concat(src, "\" />");
};

/**
 * @alias "formatters.image"
 * @param {Object|String} [value]
 * @param {String} value.id
 * @param {String} value.filename
 * @param {String} value.application_id
 * @param {String} [urlBase]
 * @param {String} [thumbKey]
 * @return {String}
 */
var imageFormatter = function imageFormatter(value, urlBase, thumbKey) {
  thumbKey = thumbKey || "original";
  var assetUrl = "https://".concat(urlBase, "/assets");
  if (_.hasIn(value, "filename")) {
    return formatIntoTag("".concat(assetUrl, "/").concat(value.application_id, "/").concat(value.id, "/").concat(thumbKey, "/").concat(value.filename));
  } else if (_typeof(value) == "string") {
    return formatIntoTag(value);
  }
  return "";
};
module.exports = imageFormatter;